import { APIAuth } from "../../utils/API"
import { emptyObject, hasProps, isEmpty } from "../../utils/Helper"

export async function getPriceReqDetail(id) {
    return APIAuth.get(`group/request-price/detail/${id}`)
        .then((res) => res.data?.data ?? undefined)
        .catch((err) => err?.response ?? err?.data?.data ?? undefined)
}

export async function getPriceReqList(payload = {}) {
    const postData = new FormData()
    if (hasProps(payload, "page")) postData.append("limit", payload?.limit ?? 10)
    if (hasProps(payload, "page")) postData.append("page", payload?.page ?? 1)
    if (hasProps(payload, "q")) postData.append("q", JSON.stringify(payload?.q ?? {}))
    if (hasProps(payload, "company_id")) postData.append("company_id", payload?.company_id)
    if (hasProps(payload, "status")) postData.append("status", payload?.status)
    if (hasProps(payload, "start_date")) postData.append("start_date", payload?.start_date)
    if (hasProps(payload, "end_date")) postData.append("end_date", payload?.end_date)
    if (hasProps(payload, "sku_name") && !isEmpty(payload?.sku_name)) postData.append("sku_name", payload?.sku_name ?? "")
    if (!emptyObject(payload?.ob ?? {}) && hasProps(payload, "ob")) {
        postData.append("ob", JSON.stringify(payload?.ob ?? {}))
    }
    return APIAuth.post(`group/request-price/list`, postData)
        .then((res) => res.data)
        .catch((err) => err?.response ?? err?.data)
}

export async function createPriceReq(payload = {}) {
    delete payload.id
    const postData = Object.keys(payload).reduce((formData, key) => {
        formData.append(key, payload[key] ?? "")
        return formData
    }, new FormData())
    return APIAuth.post(`group/request-price`, postData)
        .then((res) => res.data)
        .catch((err) => err?.response ?? err?.data)
}

export async function updatePriceReqStatus({ id, status, note = "", margin_price }) {
    const postData = { status }
    if (!isEmpty(note)) postData.note = note
    if (!isEmpty(margin_price)) postData.margin_price = margin_price
    return APIAuth.patch(`group/request-price/${id}`, postData)
        .then((res) => res.data)
        .catch((err) => err?.response ?? err?.data)
}